import { DateInput, TextInput } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import PessoaFisicaAutocomplete from './PessoaFisicaAutocomplete';

const PessoaFisica = (props) => {
  const { handleChange, handleBlur, touched, errors, readOnly, disabled, papel, fetchPapel } = props;
  const { pessoa } = props;

  const { pessoaFisica = {}, inscricaoMunicipal } = pessoa || {};
  const { identidade, dataNascimento, identificadorEstrangeiro } = pessoaFisica;

  return (
    <>
      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <PessoaFisicaAutocomplete
          value={pessoa}
          onChange={handleChange}
          onBlur={handleBlur}
          touched={touched?.pessoa?.pessoaFisica?.cpf}
          error={errors?.pessoa?.pessoaFisica?.cpf}
          disabled={disabled}
          papel={papel}
          fetchPapel={fetchPapel}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <TextInput
          readOnly={readOnly}
          fullWidth
          id="pessoa.pessoaFisica.identidade"
          label="Identidade"
          value={identidade}
          onChange={handleChange}
          maxLength={10}
          touched={touched?.pessoa?.pessoaFisica?.identidade}
          error={errors?.pessoa?.pessoaFisica?.identidade}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <DateInput
          fullWidth
          readOnly={readOnly}
          disableFuture
          id="pessoa.pessoaFisica.dataNascimento"
          label="Data de nascimento"
          value={dataNascimento}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <TextInput
          readOnly={readOnly}
          fullWidth
          id="pessoa.pessoaFisica.identificadorEstrangeiro"
          label="Identificador estrangeiro"
          onChange={handleChange}
          value={identificadorEstrangeiro}
          maxLength={15}
          touched={touched?.pessoa?.pessoaFisica?.identificadorEstrangeiro}
          error={errors?.pessoa?.pessoaFisica?.identificadorEstrangeiro}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <TextInput
          readOnly={readOnly}
          fullWidth
          id="pessoa.inscricaoMunicipal"
          label="Inscrição municipal"
          onChange={handleChange}
          value={inscricaoMunicipal}
          maxLength={20}
          error={errors?.pessoa?.inscricaoMunicipal}
          touched={touched?.pessoa?.inscricaoMunicipal}
        />
      </Grid>
    </>
  );
};

PessoaFisica.defaultProps = {
  pessoa: {
    pessoaFisica: {
      dataNascimento: null,
    },
  },
};

PessoaFisica.propTypes = {
  pessoa: PropTypes.shape({
    pessoaFisica: PropTypes.shape({
      cpf: PropTypes.string,
      identidade: PropTypes.string,
      dataNascimento: PropTypes.any,
      identificadorEstrangeiro: PropTypes.string,
    }),
  }),
};

export default PessoaFisica;
